
import { Fragment, useEffect, useState } from 'react';

import classes from './PassKeyExceedingQuotaPopup.module.scss';
import bird from '../../../../assets/img/BirdWithFlowerpot.png';


declare function Translate(key: string): string;
declare var _loginTypeWebAuthn: any;

const PassKeyExceedingQuotaPopup = (props) => {
      
    useEffect(() => {
        document.getElementById('btnPkExQt')?.focus();
    },[]);

    const handleContinueClick = () => {  
      localStorage.setItem('preferredLoginType', _loginTypeWebAuthn );            
      props.Continue();
    };

    const handleContinuePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleContinueClick();
        }        
    };

    const handleEscape = (event) => {       
        if (event.keyCode === 27){
            props.close();
        }
    };
             
    return(
       <Fragment >
            <div id='popupContainer' 
                    tabIndex={0} 
                    className={classes.popup_box} 
                    role="dialog" 
                    aria-labelledby="popupTitle" 
                    aria-describedby="popupDesc"
                    onKeyDown={handleEscape}
            >
                <div className={classes.content}>
                    <div>
                        <img alt='' src={bird} aria-hidden="true"/> 
                    </div>
                    <div className={classes.popup_title} id='popupTitle' role="heading" aria-level={2}>
                        {Translate('N_PasskeyManagment_CountLimit_2')}                        
                    </div>
                    <div className={classes.popup_desc} id='popupDesc' >
                        {Translate('N_Passkey_Exceeding_Quota')}                        
                    </div>
                
                    <div className={classes.popup_button_container}>
                        <button 
                            id='btnPkExQt'
                            className={classes.popup_button}
                            onClick={handleContinueClick}
                            onKeyPress={handleContinuePress}
                            tabIndex={0}
                        >
                            {Translate('N_General_Continue_To_Service')}                            
                        </button>                       
                    </div>                  
                </div>               
            </div>
       </Fragment>

       
    );
};
export default PassKeyExceedingQuotaPopup;
